<template>
    <b-card
        border-variant="secondary"
        align="center"
        style="max-width: 50rem;"
        class="mx-auto"
        no-body>
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.deviceInfoCollapse variant="secondary">{{ $t('nav.guestWifi') }}</b-button>
      </b-card-header>
      <b-collapse id="deviceInfoCollapse" visible >
        <b-card-body>
          <b-row  class="justify-content-sm-center border-bottom border-light">
            <UnitSecret class="mt-0 mb-2 text-center"  align-h="center" :label="$t('unitInfo.guestSecret')"
                       showChange=true :secret="this.$store.getters.getUnitGuestSecret" secretType="GUEST" />
          </b-row>
          <UnitDevices class="mt-2" type="GUEST" :caption="$t('unitInfo.guestDeviceCaption')" />
        </b-card-body>
      </b-collapse>
    </b-card>
</template>
<script>

import store from "../store/store";
import UnitDevices from "@/components/UnitDevicesTable";
import UnitSecret from "@/components/UnitSecret";
export default {
  name: 'GuestInfo',
  components: {
    UnitDevices,
    UnitSecret,
  },
  async mounted () {
    await store.getters.getUnitGuestSecret
  },
  methods: {
  }
}
</script>